<template>
  <div>
    <SnackbarComponent
      v-model="snackbar.show"
      :message="snackbar.message"
      :color="snackbar.color"
    />
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card>
        <v-card-title class="text-h5 pa-4"> Create Category </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <v-form ref="form" v-model="valid">
            <div class="mb-4">
              <v-text-field
                v-model="formData.category_name"
                :rules="[(v) => !!v || 'Category Name is required']"
                label="Category Name"
                variant="outlined"
                density="compact"
                class="mb-2"
                required
              ></v-text-field>
            </div>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="handleClose">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            variant="flat"
            :disabled="!valid || loading"
            :loading="loading"
            @click="handleSubmit"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { create_master_medication_category } from "@/graphql/mutations";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";

export default {
  name: "CreateCategoryDialog",
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "created"],
  data() {
    return {
      valid: false,
      loading: false,
      formData: {
        category_name: "",
      },
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    modelValue(newVal) {
      if (!newVal) {
        this.resetForm();
      }
    },
  },
  methods: {
    handleClose() {
      this.dialog = false;
      this.resetForm();
    },
    resetForm() {
      this.formData = {
        category_name: "",
      };
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    async handleSubmit() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        return;
      }

      this.loading = true;

      try {
        const input = {
          medication_category_name: this.formData.category_name.trim(),
        };

        const response = await client.graphql({
          query: create_master_medication_category,
          variables: {
            input,
          },
        });

        const responseData = JSON.parse(
          response.data.create_master_medication_category
        );

        if (responseData.status == "SUCCESS") {
          this.loading = false;
          this.snackbar = {
            show: true,
            message:
              responseData.status_message || "Category created successfully",
            color: "success",
          };
          this.$emit("created", 0);
          this.handleClose();
        } else {
          this.loading = false;
          this.snackbar = {
            show: true,
            message:
              responseData.status_message || "Failed to create category",
            color: "error",
          };
        }
      } catch (error) {
        this.loading = false;
        console.error("Error creating category:", error);
        this.snackbar = {
          show: true,
          message:
            error.message || "An error occurred while creating the category",
          color: "error",
        };
      }
    },
  },
};
</script>
